import { IFreeInputBehavior, IFreeInputBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanFreeInputtable } from "../../../beans/objects";

export class FreeInputBehaviorTranslator {
  from(bean: IObjectBeanFreeInputtable): IFreeInputBehavior {
    return {
      isEnable: (bean["@free-input-enable"] !== "0"),
    };
  }

  to(o: IFreeInputBehaviorSpecifiable) {
    return {
      freeInputEnable: o.freeInputBehavior.isEnable
        ? undefined
        : "0",
    };
  }
}
